/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_ACTIONS_COMPLETION_PERCENTAGE = gql`
  query ActionsCompletionPercentage($data: ActionsInput!) {
    actionsPercentCompleted(data: $data) {
      numerator
      denominator
    }
  }
`
